import React, { useState } from "react";
import { useSelector } from "react-redux";
import Glossaries from "../components/dumb/tables/Glossaries";
import { extractIDsDataAsArray } from "../helpers/mapRow";
import useAuthEffect from "../hook/useAuthEffect";
import useEffectWithoutLoad from "../hook/useEffectWithoutLoad";
import useStatusThunk from "../hook/useStatusThunk";
import { fetchGlossariesByTask } from "../redux/ducks/glossary";
const TaskGlossariesRoute = ({ match }) => {

    const taskID = match.params.taskID;
    const glossaries = useSelector(state => state.glossary.glossaries);
    const taskGlossaries = useSelector(state => state.task.tasks[taskID]?.glossaries);
    const [rows, setRows] = useState([]);

    const [d_fetchGlossariesByTask, status, error, e] = useStatusThunk(fetchGlossariesByTask);

    useAuthEffect(() => d_fetchGlossariesByTask({ taskID }), []);

    useEffectWithoutLoad(() => {
        setRows(extractIDsDataAsArray(taskGlossaries, glossaries));
    }, [glossaries, taskGlossaries]);

    return (
        <React.Fragment>
            <div className="columns-container">

                <div className="column column--primary">
                    <Glossaries rows={rows} titleContent=" " glossaryURL={"/task/" + taskID + "/glossary/:glossaryID"} />
                </div>
            </div >
        </React.Fragment>
    )
}

export default TaskGlossariesRoute;